export enum TrackKind {
    Subtitles = 'subtitles',
    Captions = 'captions',
    Descriptions = 'descriptions',
    Chapters = 'chapters',
    Metadata = 'metadata'
}
